(function () {
  var dialog = document.getElementById("rootine-signup-popup");
  if (!dialog || typeof dialog.showModal !== "function") return;

  var panel = dialog.querySelector(".signup-popup__panel");
  var logo = dialog.querySelector("[data-config-image='logo']");
  var closeButton = dialog.querySelector("[data-signup-popup-close]");
  var dismissButton = dialog.querySelector("[data-signup-popup-dismiss]");
  var copyButton = dialog.querySelector("[data-signup-popup-copy]");
  var success = dialog.querySelector("[data-signup-popup-success]");
  var preview = dialog.getAttribute("data-preview") === "true";
  var storageKey = "rootine-signup-popup-dismissed-at";
  var seenKey = "rootine-signup-popup-seen";
  var opened = false;
  var skipReported = false;
  var config = null;

  function rememberDismiss() {
    if (preview) return;
    var frequency = (config && config.frequency) || "once_a_day";
    try {
      if (frequency === "session") {
        window.sessionStorage.setItem(storageKey, "1");
      } else if (frequency !== "every_page") {
        window.localStorage.setItem(storageKey, String(Date.now()));
      }
      window.localStorage.setItem(seenKey, "1");
    } catch (error) {
      return;
    }
  }

  function frequencyBlocks() {
    var frequency = (config && config.frequency) || "once_a_day";
    try {
      if (frequency === "every_page") return false;
      if (frequency === "session") return window.sessionStorage.getItem(storageKey) === "1";
      var raw = window.localStorage.getItem(storageKey);
      var dismissedAt = Number(raw);
      if (!raw || !Number.isFinite(dismissedAt)) return false;
      var windowMs = frequency === "once_a_week" ? 7 : frequency === "once" ? 3650 : 1;
      return Date.now() - dismissedAt < windowMs * 24 * 60 * 60 * 1000;
    } catch (error) {
      return false;
    }
  }

  function pathOf(value) {
    try {
      var url = new URL(value, window.location.origin);
      var path = url.pathname || "/";
      try {
        path = decodeURIComponent(path);
      } catch (error) {
        /* Keep the raw path when it is not valid encoding. */
      }
      return path.replace(/\/+$/, "") || "/";
    } catch (error) {
      return "";
    }
  }

  function onTestPage(testUrl) {
    var expected = pathOf(testUrl || "");
    if (!expected || expected === "/") return false;
    return pathOf(window.location.href) === expected;
  }

  function seenBefore() {
    try {
      return window.localStorage.getItem(seenKey) === "1";
    } catch (error) {
      return false;
    }
  }

  function report(event, reason, trigger) {
    if (event === "skipped") {
      if (skipReported) return;
      skipReported = true;
    }
    var configUrl = dialog.getAttribute("data-config-url") || "";
    if (!configUrl) return;
    var payload = {
      event: event,
      reason: reason || "",
      trigger: trigger || "",
      path: window.location.pathname,
      loggedIn: dialog.getAttribute("data-customer") === "true",
      seenBefore: seenBefore(),
      testing: !!(config && config.testing === true),
    };
    fetch(configUrl.replace("popup-config", "popup-log"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(function () {
      return;
    });
  }

  function blockReason() {
    if (!config) return "";
    var audience = config.audience || {};
    var isContact = dialog.getAttribute("data-customer") === "true";
    if (isContact && audience.contacts === false) return "audience_contact";
    if (!isContact && audience.visitors === false) return "audience_visitor";
    var phone = window.matchMedia("(max-width: 767px)").matches;
    if (phone && audience.phones === false) return "audience_phone";
    if (!phone && audience.computers === false) return "audience_computer";
    if (audience.visitorType === "new" && seenBefore()) return "visitor_new";
    if (audience.visitorType === "returning" && !seenBefore()) return "visitor_returning";
    if (frequencyBlocks()) return "frequency";
    return "";
  }

  function openPopup(trigger) {
    if (opened || dialog.open) return;
    if (pathOf(window.location.href) === "/cart") {
      report("skipped", "cart_page", trigger || "");
      return;
    }
    var reason = blockReason();
    if (reason) {
      report("skipped", reason, "");
      return;
    }
    opened = true;
    dialog.showModal();
    report("opened", "", trigger || "");
  }

  function closePopup() {
    if (dialog.open) {
      dialog.close();
      report("dismissed", "", "");
    }
    rememberDismiss();
  }

  function applyConfig(next) {
    config = next;
    var text = next.text || {};
    dialog.querySelectorAll("[data-config]").forEach(function (node) {
      var key = node.getAttribute("data-config");
      if (!key || typeof text[key] !== "string") return;
      if (node.tagName === "INPUT") node.setAttribute("placeholder", text[key]);
      else node.textContent = text[key];
    });
    if (copyButton && typeof text.couponCode === "string") {
      copyButton.setAttribute("data-code", text.couponCode);
      var note = dialog.querySelector("[data-config='couponNote']");
      var codeBox = copyButton;
      var showCode = text.couponCode.trim() !== "";
      if (note) note.hidden = !showCode;
      codeBox.hidden = !showCode;
    }
    var images = next.images || {};
    if (logo && images.logoUrl) {
      logo.hidden = false;
      logo.setAttribute("src", images.logoUrl);
      var brand = dialog.querySelector(".signup-popup__brand");
      var badge = dialog.querySelector(".signup-popup__badge");
      if (brand) brand.hidden = true;
      if (badge) badge.hidden = true;
    }
    if (panel && images.backgroundUrl) {
      panel.style.backgroundImage = "url('" + images.backgroundUrl + "')";
      panel.style.backgroundRepeat = "repeat";
      panel.style.backgroundSize =
        (images.backgroundWidth || 724) + "px " + (images.backgroundHeight || 1024) + "px";
    }
    var photo = dialog.querySelector("[data-config-image='success']");
    if (photo) {
      if (images.successUrl) photo.setAttribute("src", images.successUrl);
      if (images.successHeight) photo.style.height = images.successHeight + "px";
    }
  }

  function armTriggers() {
    var triggers = (config && config.triggers) || {};
    if (preview) {
      openPopup("preview");
      return;
    }
    if (triggers.delayEnabled) {
      window.setTimeout(function () {
        openPopup("delay");
      }, Math.max(0, Number(triggers.delaySeconds) || 0) * 1000);
    }
    if (triggers.exitIntent) {
      document.addEventListener("mouseout", function (event) {
        if (window.matchMedia("(max-width: 767px)").matches) return;
        if (event.relatedTarget) return;
        if (event.clientY > 8) return;
        openPopup("exit");
      });
    }
    if (triggers.scrollEnabled) {
      var onScroll = function () {
        var scrolling = document.scrollingElement || document.documentElement;
        var scrolled = Math.max(window.scrollY || 0, scrolling.scrollTop || 0, document.body.scrollTop || 0);
        var height = Math.max(scrolling.scrollHeight || 0, document.body.scrollHeight || 0) - window.innerHeight;
        if (height <= 0) return;
        if ((scrolled / height) * 100 >= Number(triggers.scrollPercent || 50)) openPopup("scroll");
      };
      window.addEventListener("scroll", onScroll, { passive: true, capture: true });
      document.addEventListener("scroll", onScroll, { passive: true, capture: true });
    }
    if (triggers.addToCart) {
      document.addEventListener("submit", function (event) {
        var form = event.target;
        if (form && form.getAttribute && /\/cart\/add/.test(form.getAttribute("action") || "")) {
          window.setTimeout(function () {
            openPopup("cart");
          }, 400);
        }
      });
    }
    if (triggers.outOfStock) {
      var soldOut = document.querySelector("button[name='add'][disabled], [data-add-to-cart][disabled]");
      if (soldOut) openPopup("stock");
    }
    if (triggers.afterPurchase && /checkout|thank/i.test(document.referrer || "")) {
      openPopup("purchase");
    }
    if (triggers.hoverEnabled && triggers.hoverSelector) {
      try {
        var hoverTarget = document.querySelector(triggers.hoverSelector);
        if (hoverTarget) hoverTarget.addEventListener("mouseenter", function () {
          openPopup("hover");
        });
      } catch (error) {
        /* Ignore an invalid selector. */
      }
    }
    if (triggers.clickEnabled && triggers.clickSelector) {
      try {
        var clickTarget = document.querySelector(triggers.clickSelector);
        if (clickTarget) clickTarget.addEventListener("click", function () {
          openPopup("click");
        });
      } catch (error) {
        /* Ignore an invalid selector. */
      }
    }
    if (triggers.customEventEnabled && triggers.customEventName) {
      window.addEventListener(triggers.customEventName, function () {
        openPopup("custom");
      });
    }
  }

  dialog.querySelectorAll("[data-signup-popup-close], [data-signup-popup-dismiss]").forEach(function (button) {
    button.addEventListener("click", function (event) {
      event.preventDefault();
      closePopup();
    });
  });
  document.addEventListener("click", function (event) {
    if (!dialog.open || !panel || panel.contains(event.target)) return;
    closePopup();
  });
  if (copyButton) {
    copyButton.addEventListener("click", function () {
      var code = copyButton.getAttribute("data-code") || "";
      var done = function () {
        copyButton.classList.add("is-copied");
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done);
      } else {
        done();
      }
    });
  }
  dialog.addEventListener("cancel", function (event) {
    event.preventDefault();
    closePopup();
  });

  var signupForm = dialog.querySelector("form");
  if (signupForm) {
    signupForm.noValidate = true;
    signupForm.addEventListener("submit", function (event) {
      var email = signupForm.querySelector("input[type='email']");
      var phone = signupForm.querySelector("input[type='tel']");
      var alertBox = dialog.querySelector("[data-signup-popup-alert]");
      var emailValue = email ? email.value.trim() : "";
      var phoneValue = phone ? phone.value.trim() : "";
      var message = "";
      var field = null;
      var digits = phoneValue.replace(/[\s\-()]/g, "");
      if (digits.charAt(0) === "+") digits = digits.slice(1);
      if (digits.indexOf("972") === 0) digits = "0" + digits.slice(3);
      if (!emailValue) {
        message = "נא להזין כתובת אימייל";
        field = email;
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(emailValue)) {
        message = "כתובת האימייל אינה תקינה";
        field = email;
      } else if (!phoneValue) {
        message = "נא להזין מספר טלפון נייד";
        field = phone;
      } else if (!/^05\d{8}$/.test(digits)) {
        message = "מספר הטלפון אינו תקין";
        field = phone;
      }
      dialog.querySelectorAll(".signup-popup__input").forEach(function (input) {
        input.removeAttribute("aria-invalid");
      });
      if (!message) {
        if (alertBox) alertBox.hidden = true;
        return;
      }
      event.preventDefault();
      if (alertBox) {
        alertBox.hidden = false;
        alertBox.textContent = message;
      }
      if (field) {
        field.setAttribute("aria-invalid", "true");
        field.focus();
      }
    });
  }

  if (success) {
    opened = true;
    if (!dialog.open) dialog.showModal();
    report("signed_up", "form_posted", "");
    rememberDismiss();
    return;
  }

  var configUrl = dialog.getAttribute("data-config-url");
  if (!configUrl) {
    armTriggers();
    return;
  }
  fetch(configUrl + (configUrl.indexOf("?") === -1 ? "?" : "&") + "v=" + Date.now())
    .then(function (response) {
      return response.ok ? response.json() : null;
    })
    .then(function (next) {
      if (!next) {
        report("skipped", "config_error", "");
        return;
      }
      config = next;
      var testingHere = next.testing === true && onTestPage(next.testUrl);
      if (next.testing === true && !testingHere) {
        report("skipped", "testing_page", "");
        return;
      }
      if (!testingHere && next.enabled !== true) {
        report("skipped", "disabled", "");
        return;
      }
      applyConfig(next);
      armTriggers();
    })
    .catch(function () {
      report("skipped", "config_error", "");
    });
})();
